import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full bg-brand-card py-20 md:py-28 px-6" data-id="element-492">
      <div className="max-w-5xl mx-auto" data-id="element-493">
        <motion.p className="text-2xl md:text-3xl text-brand-dark/60 text-center mb-3" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-494">
          Resultados reales de personas como vos
        </motion.p>

        <motion.h2 className="text-2xl md:text-3xl font-bold text-brand-dark text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-495">
          Esto dicen quienes ya están aplicando el curso 👇
        </motion.h2>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-496">
          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-497">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-498">
              "Por fin alguien que te explica las cosas de forma simple. Dejé de
              dar vueltas y empecé a{' '}
              <span className="text-brand-green font-semibold" data-id="element-499">avanzar</span> de
              verdad."
            </p>
            <div className="flex items-center gap-3" data-id="element-500">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-501">
                M
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-502">
                Martina
              </span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-503">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-504">
              "Había probado de todo y nada me funcionaba. Este curso me dio la{' '}
              <span className="text-brand-green font-semibold" data-id="element-505">claridad</span>{' '}
              que necesitaba para elegir un camino y seguirlo."
            </p>
            <div className="flex items-center gap-3" data-id="element-506">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-507">
                L
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-508">Lucas</span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-509">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-510">
              &quot;Lo mejor es que va directo al punto. Sin relleno, sin
              promesas exageradas. Justo{' '}
              <span className="text-brand-green font-semibold" data-id="element-511">
                lo que necesitaba
              </span>{' '}
              para empezar."
            </p>
            <div className="flex items-center gap-3" data-id="element-512">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-513">
                S
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-514">Sofía</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}